/**
 * Gets env variable from window._env object
 * added in runtime by /static/env-vars.js script.
 *
 * @param {string} varName Name
 * @param {boolean} useLocalStoreOverride Check localStorage to have the same key and use as an override.
 * @returns {string}
 */
export function getEnvVar(varName, useLocalStoreOverride = false) {
    if (useLocalStoreOverride && localStorage.getItem(varName)) {
        return localStorage.getItem(varName) || '';
    }

    if (!window || !window._env_) {
        return '';
    }

    return window._env_[varName];
}
